import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const CTASection = ({
    title,
    description,
    buttonText,
    buttonLink = "https://wa.me/34610683948",
    icon = "ph-bold ph-question",
    iconType = "icon" // "icon" or "image"
}) => {
    const { t } = useLanguage();
    return (
        <div className="mxd-section overflow-hidden">
            <div className="mxd-container">
                <div className="mxd-block">
                    <div className="mxd-promo">
                        <div className="mxd-promo__inner anim-zoom-out-container">
                            <div className="mxd-promo__bg"></div>
                            <div className="mxd-promo__content">
                                <p className="mxd-promo__title anim-uni-in-up">
                                    <span className="mxd-promo__icon">
                                        {iconType === "image" ? (
                                            <img src={icon} alt={t('common.alt_texts.icon')} />
                                        ) : (
                                            <i className={icon}></i>
                                        )}
                                    </span>
                                    <span className="mxd-promo__caption reveal-type">{title}</span>
                                </p>
                                {description && (
                                    <p className="mxd-promo__description">
                                        {description}
                                    </p>
                                )}
                                <div className="mxd-promo__controls anim-uni-in-up">
                                    <a
                                        className="btn btn-anim btn-primary btn-large slide-right-up btn-long-text"
                                        href={buttonLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span className="btn-caption">{buttonText}</span>
                                        <i className="ph-bold ph-arrow-up-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CTASection;
